import axios from 'axios';
import { API_URL } from 'config/URL/URL';

const DEFAULT_SRS = 'EPSG:3857';

const buildExtentParam = (extent) => {
    if (!extent || extent.length !== 4) return undefined;
    return extent.join(',');
};

export const fetchLifestyleInfo = async ({ endpoint, extent, layerName }) => {
    const response = await axios.get(`${API_URL}/lifestyle/${endpoint}`, {
        params: {
            extent: buildExtentParam(extent),
            srsname: DEFAULT_SRS,
            layerName,
            outputFormat: 'application/json',
        },
    });
    return response.data;
};

export const fetchAdmAreaInfo = async (hjdCd) => {
    const response = await axios.get(`${API_URL}/admArea/getAdmInfo`, {
        params: {
            hjdCd,
        },
    });
    return response.data;
};

export const fetchLifestyleRadiusInfo = async ({ coordinate, radius, layerName }) => {
    const response = await axios.get(`${API_URL}/lifestyle/getInfoRadius`, {
        params: {
            x: coordinate?.[0],
            y: coordinate?.[1],
            radius,
            layerName,
        },
    });
    return response.data;
};
